const setCreditFlipped = (card, flipped) => {
  const flipButton = card.querySelector('[data-rpg-credit-flip]');
  card.classList.toggle('is-flipped', flipped);
  flipButton?.setAttribute('aria-pressed', String(flipped));
  flipButton?.setAttribute('aria-label', `${flipped ? 'Show front of' : 'Show details for'} ${card.querySelector('h3')?.textContent.trim() || 'profile'}`);
  requestAnimationFrame(() => updateCreditOverflow(card));
};

const copyCreditText = async (value) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value);
    return;
  }

  const input = document.createElement('textarea');
  input.value = value;
  input.setAttribute('readonly', '');
  input.style.position = 'fixed';
  input.style.opacity = '0';
  document.body.appendChild(input);
  input.select();
  document.execCommand('copy');
  input.remove();
};

const affiliateIconPaths = {
  instagram: ['0 0 20 20', 'M10 5.2a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6Zm0 7.7a2.9 2.9 0 1 1 0-5.8 2.9 2.9 0 0 1 0 5.8ZM15.3 4.7a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4ZM5.9.1h8.2C17.8.1 20 2.3 20 5.9v8.2c0 3.6-2.2 5.8-5.9 5.8H5.9C2.2 19.9 0 17.7 0 14.1V5.9C0 2.3 2.2.1 5.9.1Zm0 1.8c-2.7 0-4 1.3-4 4v8.2c0 2.7 1.3 4 4 4h8.2c2.7 0 4-1.3 4-4V5.9c0-2.7-1.3-4-4-4H5.9Z'],
  youtube: ['0 0 48 34', 'M47.5 7.3S47 4 45.6 2.5C43.8.6 41.7.6 40.8.5 34.1 0 24 0 24 0S13.9 0 7.2.5C6.3.6 4.2.6 2.4 2.5.9 4 0 15.2 0 15.2v3.6c0 3.9.5 7.8.5 7.8s.4 3.3 1.9 4.8c1.8 1.9 4.2 1.9 5.3 2.1C11.5 33.9 24 34 24 34s10.1 0 16.8-.5c.9-.1 3-.1 4.8-2 1.4-1.5 1.9-4.8 1.9-4.8s.5-3.9.5-7.8v-3.7c0-3.9-.5-7.9-.5-7.9ZM19 23.3V9.7l13 6.8-13 6.8Z'],
  twitch: ['0 0 24 24', 'M11.6 4.7h1.7v5.2h-1.7V4.7Zm4.7 0H18v5.2h-1.7V4.7ZM6 0 1.7 4.3v15.4h5.2V24l4.2-4.3h3.5l7.7-7.7V0H6Zm14.6 11.1-3.5 3.5h-3.4l-3 3v-3H6.9V1.7h13.7v9.4Z'],
  tiktok: ['0 0 16 16', 'M8 .1h2.7c.1 1 .4 2 1.2 2.7.7.8 1.8 1.1 2.8 1.2v2.7c-1.4 0-2.8-.5-3.9-1.3v5.8A5 5 0 1 1 6.6 6v3a2.2 2.2 0 1 0 1.4 2.1V.1Z'],
  facebook: ['0 0 24 24', 'M24 12A12 12 0 1 0 10.1 23.9v-8.4h-3V12h3V9.4c0-3 1.8-4.7 4.6-4.7 1.3 0 2.7.2 2.7.2V8h-1.6c-1.5 0-1.9.9-1.9 1.8V12h3.3l-.5 3.5h-2.8v8.4A12 12 0 0 0 24 12Z'],
  twitter: ['0 0 24 24', 'M18.2 2.3h3.3l-7.2 8.2 8.5 11.2h-6.7l-5.2-6.8-6 6.8H1.7l7.7-8.8L1.3 2.3h6.8l4.7 6.2 5.4-6.2Zm-1.1 17.5h1.8L7.1 4.1H5.1l12 15.7Z'],
  linkedin: ['0 0 20 20', 'M.5 6.4h3.9V20H.5V6.4Zm1.9-1.7A2.4 2.4 0 1 1 2.4 0a2.4 2.4 0 0 1 0 4.7ZM20 20h-4.4v-7c0-1.8-.7-3.1-2.2-3.1-1.2 0-1.8.8-2.2 1.7-.1.3-.1.7-.1 1.1V20H6.8V6.4h4.4v2.1c.6-1 1.7-2.2 3.9-2.2 2.8 0 4.9 2 4.9 6.2V20Z'],
  website: ['0 0 24 24', 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm6.9 6h-3a15 15 0 0 0-1.4-3.4A8.1 8.1 0 0 1 18.9 8ZM12 4c.8 1 1.5 2.3 1.9 4h-3.8C10.5 6.3 11.2 5 12 4ZM4.3 14a8 8 0 0 1 0-4h4.1a17 17 0 0 0 0 4H4.3Zm.8 2h3.3c.3 1.3.7 2.5 1.3 3.5A8.1 8.1 0 0 1 5.1 16ZM12 20c-.8-1-1.5-2.3-1.9-4h3.8c-.4 1.7-1.1 3-1.9 4Zm2.3-.5c.6-1 1-2.2 1.3-3.5h3.3a8.1 8.1 0 0 1-4.6 3.5ZM15.9 14h-7.8a15 15 0 0 1 0-4h7.8a15 15 0 0 1 0 4Z'],
};
const affiliateSocialIcon = (platform) => { const icon = affiliateIconPaths[platform] || affiliateIconPaths.website; const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); svg.setAttribute('viewBox', icon[0]); svg.setAttribute('aria-hidden', 'true'); const path = document.createElementNS(svg.namespaceURI, 'path'); path.setAttribute('d', icon[1]); path.setAttribute('fill', 'currentColor'); svg.appendChild(path); return svg; };
const renderAffiliateCredits = async () => {
  const credits = document.querySelector('[data-rpg-credits]'); if (!credits) return;
  try {
    const response = await fetch('https://right-pricer.weathered-water-e9b4.workers.dev/storefront/affiliates', { mode: 'cors' }); if (!response.ok) return;
    const { affiliates = [] } = await response.json(); if (!affiliates.length) return;
    const group = document.createElement('div'); group.className = 'rpg-credits__group rpg-credits__group--affiliates'; const heading = document.createElement('h2'); heading.textContent = 'Affiliates'; const people = document.createElement('div'); people.className = 'rpg-credits__people';
    affiliates.forEach((affiliate) => { const card = document.createElement('article'); card.className = 'rpg-credit-card rpg-credit-card--affiliate'; const inner = document.createElement('div'); inner.className = 'rpg-credit-card__inner'; const face = document.createElement('div'); face.className = `rpg-credit-card__face rpg-credit-card__front${affiliate.socialLinks?.length ? '' : ' rpg-credit-card__front--no-socials'}`; const portrait = document.createElement('div'); portrait.className = 'rpg-credit-card__portrait';
      if (affiliate.imageUrl) { const image = document.createElement('img'); image.src = affiliate.imageUrl; image.alt = affiliate.name; image.loading = 'lazy'; portrait.appendChild(image); } else { const fallback = document.createElement('div'); fallback.className = 'rpg-credit-card__portrait-placeholder'; fallback.textContent = (affiliate.name || '?').charAt(0).toUpperCase(); portrait.appendChild(fallback); }
      const identity = document.createElement('div'); identity.className = 'rpg-credit-card__identity'; const name = document.createElement('h3'); name.textContent = affiliate.name; const subtitle = document.createElement('p'); subtitle.textContent = affiliate.subtitle || 'RPG Affiliate'; identity.append(name, subtitle); face.append(portrait, identity);
      if (affiliate.socialLinks?.length) { const socials = document.createElement('div'); socials.className = 'rpg-credit-card__socials'; socials.setAttribute('aria-label', `Social links for ${affiliate.name}`); affiliate.socialLinks.forEach((social) => { const link = document.createElement('a'); link.href = social.url; link.target = '_blank'; link.rel = 'noopener noreferrer'; link.setAttribute('aria-label', `${social.platform} profile`); link.appendChild(affiliateSocialIcon(social.platform)); socials.appendChild(link); }); face.appendChild(socials); }
      inner.appendChild(face); card.appendChild(inner); people.appendChild(card); });
    group.append(heading, people); const firstGroup = credits.querySelector('.rpg-credits__group'); firstGroup?.insertAdjacentElement('afterend', group);
  } catch (_) {}
};
renderAffiliateCredits();

document.addEventListener('click', async (event) => {
  const scrollCue = event.target.closest('[data-rpg-credit-scroll-bottom]');
  if (scrollCue) {
    const card = scrollCue.closest('[data-rpg-credit-card]');
    const details = card?.querySelector('.rpg-credit-card__back .rte');
    details?.scrollTo({ top: details.scrollHeight, behavior: 'auto' });
    return;
  }
  const discordButton = event.target.closest('[data-rpg-discord-toggle]');
  document.querySelectorAll('.rpg-credit-card__discord.is-open').forEach((popup) => {
    if (!popup.contains(event.target)) {
      popup.classList.remove('is-open');
      popup.querySelector('[data-rpg-discord-toggle]')?.setAttribute('aria-expanded', 'false');
    }
  });
  if (discordButton) {
    const popup = discordButton.closest('.rpg-credit-card__discord');
    const copyValue = discordButton.dataset.rpgCopyEmail || discordButton.dataset.rpgCopyDiscord;
    if (copyValue) {
      const bubble = popup.querySelector('[data-rpg-discord-bubble]');
      try {
        await copyCreditText(copyValue);
        bubble.textContent = discordButton.dataset.rpgCopyEmail ? 'Gmail Copied!' : 'Username Copied!';
      } catch (error) {
        bubble.textContent = 'Copy failed';
      }
      popup.classList.add('is-open');
      discordButton.setAttribute('aria-expanded', 'true');
      window.clearTimeout(popup.rpgCopyCloseTimer);
      popup.rpgCopyCloseTimer = window.setTimeout(() => {
        popup.classList.remove('is-open');
        discordButton.setAttribute('aria-expanded', 'false');
      }, 2000);
      return;
    }
    const open = popup.classList.toggle('is-open');
    discordButton.setAttribute('aria-expanded', String(open));
    return;
  }
  const backDetails = event.target.closest('.rpg-credit-card__back .rte');
  if (backDetails) {
    const card = backDetails.closest('[data-rpg-credit-card]');
    if (card) setCreditFlipped(card, false);
    return;
  }
  const flipButton = event.target.closest('[data-rpg-credit-flip]');
  if (!flipButton) return;
  const card = flipButton.closest('[data-rpg-credit-card]');
  if (!card) return;
  setCreditFlipped(card, !card.classList.contains('is-flipped'));
});

const updateCreditOverflow = (card) => {
  const details = card.querySelector('.rpg-credit-card__back .rte');
  if (!details) return;
  const hasMoreBelow = details.scrollHeight > details.clientHeight + 2 && details.scrollTop + details.clientHeight < details.scrollHeight - 2;
  card.classList.toggle('has-back-overflow', hasMoreBelow);
};

const fitCreditRole = (card) => {
  const role = card.querySelector('.rpg-credit-card__identity p');
  const name = card.querySelector('.rpg-credit-card__identity h3');
  const identity = card.querySelector('.rpg-credit-card__identity');
  const front = card.querySelector('.rpg-credit-card__front');
  if (!role || !name || !identity || !front) return;
  role.style.removeProperty('font-size');
  if (!card.classList.contains('rpg-credit-card--honorable')) return;
  const nameSize = Number.parseFloat(getComputedStyle(name).fontSize);
  const maximumRatio = 0.8;
  let roleSize = Math.min(Number.parseFloat(getComputedStyle(role).fontSize), nameSize * maximumRatio);
  const minimumSize = 1;
  role.style.fontSize = `${roleSize}px`;
  const roleOverflows = () => (
    role.scrollWidth > role.clientWidth + 0.5
    || identity.scrollHeight > identity.clientHeight + 0.5
    || front.scrollHeight > front.clientHeight + 0.5
  );
  while (roleOverflows() && roleSize > minimumSize) {
    roleSize = Math.max(minimumSize, roleSize - 0.25);
    role.style.fontSize = `${roleSize}px`;
  }
};

let creditRoleFrame = 0;
const fitAllCreditRoles = () => {
  if (creditRoleFrame) return;
  creditRoleFrame = requestAnimationFrame(() => {
    creditRoleFrame = 0;
    document.querySelectorAll('.rpg-credit-card--honorable').forEach(fitCreditRole);
  });
};

document.fonts?.ready.then(fitAllCreditRoles);
window.addEventListener('resize', fitAllCreditRoles, { passive: true });
fitAllCreditRoles();

document.querySelectorAll('[data-rpg-credit-card]').forEach((card) => {
  const details = card.querySelector('.rpg-credit-card__back .rte');
  if (!details) return;
  let overflowFrame = 0;
  const queueCreditOverflow = () => {
    if (overflowFrame) return;
    overflowFrame = requestAnimationFrame(() => {
      overflowFrame = 0;
      updateCreditOverflow(card);
    });
  };
  details.addEventListener('scroll', queueCreditOverflow, { passive: true });
  new ResizeObserver(queueCreditOverflow).observe(details);
  updateCreditOverflow(card);
});
